export default "__VITE_ASSET__SDgvm5LM__"